import styles from './ContentContainer.module.css';

export function ContentContainer({ children }: { children: React.ReactNode }) {
	return <div className={styles['content-container']}>{children}</div>;
}
